/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseTehtrisTriggers } from './GetIntegrationsConfig200ResponseTehtrisTriggers';
import {
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtrisTriggers';

/**
 * 
 * @export
 * @interface UpdateIntegrationsConfigRequestNinjaOne
 */
export interface UpdateIntegrationsConfigRequestNinjaOne {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    clientId: string;
    /**
     * 
     */
    clientSecret?: string;
    /**
     * 
     */
    region: UpdateIntegrationsConfigRequestNinjaOneRegionEnum;
    /**
     * 
     */
    organizationId?: number;
    /**
     * 
     */
    defaultStatus: UpdateIntegrationsConfigRequestNinjaOneDefaultStatusEnum;
    /**
     * 
     */
    ticketType: UpdateIntegrationsConfigRequestNinjaOneTicketTypeEnum;
    /**
     * 
     */
    ticketFormId?: number;
    /**
     * 
     */
    triggers: GetIntegrationsConfig200ResponseTehtrisTriggers;
}


/**
 * @export
 */
export const UpdateIntegrationsConfigRequestNinjaOneRegionEnum = {
    Eu: 'eu',
    Us: 'us',
    Ca: 'ca',
    Oc: 'oc',
} as const;
export type UpdateIntegrationsConfigRequestNinjaOneRegionEnum = typeof UpdateIntegrationsConfigRequestNinjaOneRegionEnum[keyof typeof UpdateIntegrationsConfigRequestNinjaOneRegionEnum];

/**
 * @export
 */
export const UpdateIntegrationsConfigRequestNinjaOneDefaultStatusEnum = {
    New: 'NEW',
    Open: 'OPEN',
    Waiting: 'WAITING',
    Paused: 'PAUSED',
    Resolved: 'RESOLVED',
    Closed: 'CLOSED',
} as const;
export type UpdateIntegrationsConfigRequestNinjaOneDefaultStatusEnum = typeof UpdateIntegrationsConfigRequestNinjaOneDefaultStatusEnum[keyof typeof UpdateIntegrationsConfigRequestNinjaOneDefaultStatusEnum];

/**
 * @export
 */
export const UpdateIntegrationsConfigRequestNinjaOneTicketTypeEnum = {
    Problem: 'PROBLEM',
    Question: 'QUESTION',
    Incident: 'INCIDENT',
    Task: 'TASK',
} as const;
export type UpdateIntegrationsConfigRequestNinjaOneTicketTypeEnum = typeof UpdateIntegrationsConfigRequestNinjaOneTicketTypeEnum[keyof typeof UpdateIntegrationsConfigRequestNinjaOneTicketTypeEnum];


/**
 * Check if a given object implements the UpdateIntegrationsConfigRequestNinjaOne interface.
 */
export function instanceOfUpdateIntegrationsConfigRequestNinjaOne(value: object): value is UpdateIntegrationsConfigRequestNinjaOne {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    if (!('defaultStatus' in value) || value['defaultStatus'] === undefined) return false;
    if (!('ticketType' in value) || value['ticketType'] === undefined) return false;
    if (!('triggers' in value) || value['triggers'] === undefined) return false;
    return true;
}

export function UpdateIntegrationsConfigRequestNinjaOneFromJSON(json: any): UpdateIntegrationsConfigRequestNinjaOne {
    return UpdateIntegrationsConfigRequestNinjaOneFromJSONTyped(json, false);
}

export function UpdateIntegrationsConfigRequestNinjaOneFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIntegrationsConfigRequestNinjaOne {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'region': json['region'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'defaultStatus': json['defaultStatus'],
        'ticketType': json['ticketType'],
        'ticketFormId': json['ticketFormId'] == null ? undefined : json['ticketFormId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON(json['triggers']),
    };
}

export function UpdateIntegrationsConfigRequestNinjaOneToJSON(json: any): UpdateIntegrationsConfigRequestNinjaOne {
    return UpdateIntegrationsConfigRequestNinjaOneToJSONTyped(json, false);
}

export function UpdateIntegrationsConfigRequestNinjaOneToJSONTyped(value?: UpdateIntegrationsConfigRequestNinjaOne | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'region': value['region'],
        'organizationId': value['organizationId'],
        'defaultStatus': value['defaultStatus'],
        'ticketType': value['ticketType'],
        'ticketFormId': value['ticketFormId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersToJSON(value['triggers']),
    };
}

